// export var server:string='http://localhost:5000/api/'
// production server
export var server:string='https://vibe.verifacts.co.in/api/'
// export var reportsServer:string="https://vibe.verifacts.co.in/reportsserver/"
// export var localreportsServer:string="https://vibe.verifacts.co.in/localreports/"
// export var trackerServer:string="https://vibe.verifacts.co.in/trackers/"
// //uat server
//  export var server:string='https://cvws2.verifacts.co.in/api/'
//  export var reportsServer:string="https://cvws2.verifacts.co.in/reportsserver/"
 //export var localreportsServer:string="https://cvws2.vibe.verifacts.co.in/localreports/"
// export var trackerServer:string="https://cvws2.vibe.verifacts.co.in/trackers/"
//uat server
//export var server:string="http://15.207.82.218/api/"
//export var reportsServer:string="http://15.207.82.218/reportsserver/"
//export var localreportsServer:string="http://15.207.82.218/api/"
//export var trackerServer:string="http://15.207.82.218/api/"
// dr server
//export var server:string="http://52.66.185.152/api/"
//export var reportsServer:string="http://52.66.185.152/api/"
//export var localreportsServer:string="http://52.66.185.152/api/"
//export var trackerServer:string="http://52.66.185.152/api/"

// export var server:string="http://localhost:5000/api/"
//export var reportsServer:string="http://192.168.1.11/reportsserver/"

// export var localreportsServer:string="http://localhost:3000/localreports/"
//export var trackerServer:string="http://192.168.1.11/api/"
